import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraText } from '@mono/ui-components';
import { AiAssistBar } from '../../AiAssist';
import { usePursuitRecord } from '../PursuitRecordContext';
import { PursuitSectionFrame } from '../PursuitSectionFrame';
/** Chat (§3.3): the pursuit's assist bar; the route already wraps it in CaptureEvidenceAsk. */ export function ChatSection() {
    const { zouProjectId } = usePursuitRecord();
    return /*#__PURE__*/ _jsxs(PursuitSectionFrame, {
        title: "Chat",
        children: [
            /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                children: "Ask questions about this pursuit and get answers with sources."
            }),
            /*#__PURE__*/ _jsx(AiAssistBar, {
                zouProjectId: zouProjectId
            })
        ]
    });
}
